module.exports = __webpack_public_path__ + "static/media/friday.f799b3b8.ogg";